if (!customElements.get('dvalia-care')) {
  customElements.define('dvalia-care', class extends HTMLElement {
    connectedCallback() {
      if (this.controller || typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
      this.fallback = this.querySelector('[data-dv-care-fallback]');
      this.content = this.querySelector('[data-dv-care-content]');
      const summary = this.fallback?.querySelector('summary');
      this.closeButton = this.content?.querySelector('[data-dv-care-close]');
      if (!summary || !this.content || !this.closeButton) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.trigger = document.createElement('button');
      this.trigger.type = 'button';
      this.trigger.className = 'dv-care-trigger';
      this.trigger.textContent = summary.textContent;
      this.trigger.setAttribute('aria-haspopup', 'dialog');
      this.trigger.setAttribute('aria-controls', 'DvaliaSilkCareDialog');
      this.dialog = document.createElement('dialog');
      this.dialog.id = 'DvaliaSilkCareDialog';
      this.dialog.className = 'dv-care-modal';
      this.dialog.setAttribute('aria-labelledby', 'DvaliaSilkCareTitle');
      this.dialog.append(this.content);
      this.closeButton.hidden = false;
      this.fallback.hidden = true;
      this.prepend(this.trigger);
      this.append(this.dialog);

      this.trigger.addEventListener('click', () => this.open(), options);
      this.closeButton.addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => this.restore(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
    }

    open() {
      if (this.dialog.open) return;
      this.returnFocus = this.trigger;
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      this.closeButton.focus({ preventScroll: true });
    }

    restore() {
      document.documentElement.style.overflow = this.previousOverflow || '';
      if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
      this.returnFocus = null;
    }

    disconnectedCallback() {
      if (!this.controller) return;
      this.controller.abort();
      if (this.dialog.open) {
        this.dialog.close();
        document.documentElement.style.overflow = this.previousOverflow || '';
      }
      this.closeButton.hidden = true;
      this.fallback.append(this.content);
      this.fallback.hidden = false;
      this.trigger.remove();
      this.dialog.remove();
      this.controller = null;
    }
  });
}
